import colors from '../colors';
import * as React from 'react';
import styled, { css, StyledFunction } from 'styled-components';
import ChoiceButtonList from './ChoiceButtonList';
import AnonymousAvatar from './AnonymousAvatar';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';
import * as CarIcon from 'react-icons/lib/fa/automobile';
import * as WrenchIcon from 'react-icons/lib/fa/wrench';
import * as MoneyIcon from 'react-icons/lib/fa/money';
import * as MapIcon from 'react-icons/lib/fa/map';
import * as CalendarIcon from 'react-icons/lib/fa/calendar';
import * as BoltIcon from 'react-icons/lib/fa/bolt';
import * as HeartIcon from 'react-icons/lib/fa/heart';
import * as DashboardIcon from 'react-icons/lib/fa/dashboard';
import * as TagIcon from 'react-icons/lib/fa/tag';
import * as MobileIcon from 'react-icons/lib/fa/mobile';

interface Props {
    icon: string;
}

const LinkIcon: React.SFC<Props> = ({ icon }) => {
    const iconSize = 20;
    switch (icon) {
        case 'wrench':
            return <WrenchIcon size={iconSize} color={colors.blue} />;
        case 'money':
            return <MoneyIcon size={iconSize} color={colors.blue} />;
        case 'map':
            return <MapIcon size={iconSize} color={colors.blue} />;
        case 'calendar':
            return <CalendarIcon size={iconSize} color={colors.blue} />;
        case 'bolt':
            return <BoltIcon size={iconSize} color={colors.blue} />;
        case 'heart':
            return <HeartIcon size={iconSize} color={colors.blue} />;
        case 'tachometer':
            return <DashboardIcon size={iconSize} color={colors.blue} />;
        case 'tag':
            return <TagIcon size={iconSize} color={colors.blue} />;
        case 'mobile':
            return <MobileIcon size={iconSize} color={colors.blue} />;
        case 'car':
        default:
            return <CarIcon size={iconSize} color={colors.blue} />;
    }
};

export default LinkIcon;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/LinkIcon.tsx